<template>
  <div class="flex w-full flex-col">
    <div class="flex gap-x-2 w-full flex-col">
      <div class="flex flex-col justify-between w-full mb-2">
        <TextInput
          :value="new_text_title"
          :validate-on-input="true"
          :label="$t('Title')"
          :classes="'w-3/4'"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="name"
          type="text"
          :placeholder="$t('Text Title')"
          @update:modelValue="
            (e) => {
              new_text_title = e
              formDataChanged()
            }
          " />

        <ColorPickerList v-model:current-item="new_text_bg_color" :label="$t('Background Color')" class="w-1/4" />
      </div>

      <div class="w-full">
        <TextEditor
          :value="new_text_description"
          :show-label="false"
          toolbar="full"
          :placeholder="$t('note description')"
          name="note_text"
          :label="$t('Description')"
          theme="snow"
          input-classes="rounded-b-md"
          @changed="
            (e) => {
              new_text_description = e
              formDataChanged()
            }
          " />
      </div>
    </div>
    <label v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'" class="mt-1.5 ml-4">Show on:</label>
    <SelectInput
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      v-model="connect_to"
      :disabled="disabled_connect_to_selection"
      name="select_input"
      :allow-null="false"
      :items="connect_to_options"
      :is-box-background="true"
      :value="connect_to"
      label-attr="name"
      value-attr="value"
      :placeholder="$t('Connect to')"
      :label="$t('Connect to')"
      class="w-[200px]"
      input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />

    <div class="flex flex-row justify-between w-full gap-2 mt-2">
      <button class="cancel-btn" @click="is_loading ? null : $emit('cancel')">{{ $t("Cancel") }}</button>
      <button
        :class="[!new_text_title ? 'opacity-50' : '']"
        :disable="new_text_title == 0"
        type="button"
        class="w-fit primary-btn"
        @click="updateText()">
        {{ is_loading ? $t("Loading...") : text ? $t("Update Text") : $t("Create Text") }}
      </button>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import ColorPickerList from "@/components/shared/ColorPickerList.vue"

import TextInput from "@/components/shared/TextInput.vue"
import TextEditor from "@/components/shared/TextEditor.vue"

export default {
  components: {
    TextInput,
    ColorPickerList,
    TextEditor,
    SelectInput
  },
  props: {
    text: null
  },
  emits: ["setComponentData", "cancel", "submitForm"],
  data() {
    return {
      is_loading: false,
      new_text_bg_color: "#FAF4AF",
      new_text_title: "",
      new_text_description: "",
      connect_to: "all_pages",
      connect_to_options: [
        { name: this.$t("All Pages"), value: "all_pages" },
        { name: this.$t("This Page"), value: "this_page" }
      ],
      page_identifier: "all",
      disabled_connect_to_selection: false
    }
  },
  watch: {
    new_text_bg_color() {},
    connect_to() {
      if (this.connect_to == "this_page") {
        this.page_identifier = `${this.$route.params.object_type}>${this.$route.params.cid}`
      } else {
        this.page_identifier = "all"
      }
      if (this.setComponentData) {
        this.setComponentData()
      }
    }
  },

  created() {
    if (this.text) {
      this.disabled_connect_to_selection = true
      if (typeof this.text.props.component_props.label == "object") {
        this.connect_to = "this_page"
      }
      this.new_text_title = this.$utils.extractValue(this.text.props.component_props.label, "", this.$route)
      this.new_text_description = this.$utils.extractValue(this.text.props.component_props.description, "", this.$route)
      this.new_text_bg_color = this.$utils.extractValue(this.text.props.component_props.backgroundColor, "transparent", this.$route)
    }
  },

  methods: {
    setComponentData() {
      this.$emit("setComponentData", {
        required_filled: this.new_text_title,
        label: this.new_text_title,
        description: this.new_text_description,
        backgroundColor: this.new_text_bg_color,
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    },
    formDataChanged() {
      this.setComponentData()
    },
    updateText() {
      this.$emit("submitForm", {
        id: this.text?.id,
        label: this.new_text_title,
        description: this.new_text_description,
        backgroundColor: this.new_text_bg_color,
        component_type: "text",
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    }
  }
}
</script>
<style scoped>
.rainbow-bg {
  background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red);
}
</style>
